import { el } from 'redom';
import { Node, Path } from 'slate';
import { ReactEditor } from 'slate-react';

import * as serializer from 'basic-editor-value-serializer';

import { stringToSVG } from 'utilities';

import HelptapEditor from '../../helpers';

import addItemIconString from 'assets/images/layout-add-item-icon.svg?raw';
import removeLayoutIconString from 'assets/images/layout-remove-keep-content-icon.svg?raw';
import selectLayoutIconString from 'assets/images/layout-select-parent-icon.svg?raw';
import wrapIconString from 'assets/images/layout-wrap-icon.svg?raw';

const addItemIcon = stringToSVG(addItemIconString);
const removeLayoutIcon = stringToSVG(removeLayoutIconString);
const selectLayoutIcon = stringToSVG(selectLayoutIconString);
const wrapIcon = stringToSVG(wrapIconString);

// configuration: { editor, activeNodePath, label, icon, action(editor, path) }
class LayoutActionButton {

  constructor(menu, configuration) {

    this.menu = menu;

    this.editor = configuration.editor;
    this.activeNodePath = configuration.activeNodePath;
    this.action = configuration.action;

    this.el = el('button.layout-action-button', {
      type: 'button',
      onclick: this.handleButtonClick.bind(this)
    }, [configuration.icon.cloneNode(true), el('label', configuration.label)]);

  }

  handleButtonClick() {

    this.menu.onClose();
    this.action(this.editor, this.activeNodePath);

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.activeNodePath = configuration.activeNodePath;

  }

}

function findOwnHandle(main) {
  return main.querySelector(':scope > .node-handles-container button.editor-node-control-button');
}

// Spec 3.2: the guaranteed way to reach a layout whose children cover it. A focused handle stays
// visible, so it can also be dragged from here.
function selectLayout(editor, path) {

  const main = ReactEditor.toDOMNode(editor, Node.get(editor, Path.parent(path))).closest('.editor-node-main');

  if (main === null) {
    return;
  }

  const handle = findOwnHandle(main);

  if (handle === null) {
    return;
  }

  handle.focus();
  handle.click();

}

function wrapTargets(editor, path) {
  HelptapEditor.layout.wrapBlocksInLayout(editor, HelptapEditor.conversion.determineTargetPaths(editor, path));
}

function canWrap(editor, path) {

  if (HelptapEditor.dataCollection.isDataCollectionDescendant(editor, path) === true) {
    return false;
  }

  if (HelptapEditor.dataCollection.isDataCollectionRowPageNode(Node.get(editor, path)) === true) {
    return false;
  }

  return HelptapEditor.layout.canWrapInLayout(editor, HelptapEditor.conversion.determineTargetPaths(editor, path));

}

function buildButton(menu, options, label, icon, action) {
  return new LayoutActionButton(menu, { editor: options.editor, activeNodePath: options.activeNodePath, label, icon, action });
}

// options: { editor, node, activeNodePath }
export function buildLayoutButtons(menu, options) {

  const editor = options.editor;
  const path = options.activeNodePath;
  const buttons = [];

  if (options.node.type === serializer.types.LAYOUT) {
    buttons.push(buildButton(menu, options, 'Add item', addItemIcon, HelptapEditor.layout.addItem));
    buttons.push(buildButton(menu, options, 'Remove layout, keep content', removeLayoutIcon, HelptapEditor.layout.removeLayoutKeepContent));
  }

  if (HelptapEditor.layout.isLayoutChild(editor, path) === true) {
    buttons.push(buildButton(menu, options, 'Select layout', selectLayoutIcon, selectLayout));
  }

  if (canWrap(editor, path) === true) {
    buttons.push(buildButton(menu, options, 'Wrap in layout', wrapIcon, wrapTargets));
  }

  return buttons;

}
